import { render, staticRenderFns } from "./CompanyControl.vue?vue&type=template&id=718bbca8&scoped=true&"
import script from "./CompanyControl.vue?vue&type=script&lang=js&"
export * from "./CompanyControl.vue?vue&type=script&lang=js&"
import style0 from "./CompanyControl.vue?vue&type=style&index=0&id=718bbca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718bbca8",
  null
  
)

export default component.exports